.tarjeta {
  display: flex;
  flex-direction: column;
  gap: var(--s-6);
  padding: var(--s-7);
  background: var(--surface-card);
  border: var(--bw-hair) solid var(--border-hair);
  border-radius: var(--r-card);
}
.tarjeta[data-estado="aprobado"] {
  border-color: var(--status-warning-border);
}
.cuerpo {
  display: flex;
  gap: var(--s-8);
  align-items: flex-start;
}
.identidad {
  width: 256px;
  flex: none;
  display: flex;
  flex-direction: column;
  gap: var(--s-5);
  min-width: 0;
}
.nombre {
  display: flex;
  gap: var(--s-5);
  align-items: center;
  min-width: 0;
}
.textos {
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
  min-width: 0;
}
.enlace {
  font-family: var(--font-display);
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
  letter-spacing: -0.01em;
  line-height: 1.3;
  color: var(--text-strong);
  overflow-wrap: anywhere;
}
.enlace:hover {
  color: var(--text-link);
}
.lugar {
  display: inline-flex;
  align-items: center;
  gap: var(--s-2);
}
.badges {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s-3);
}
.mono {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
}
.contacto {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
  font-size: var(--fs-xs);
  min-width: 0;
}
.contacto li {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mensaje {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
}
.meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--s-5);
  flex-wrap: wrap;
}
.edicion {
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
}
.fila {
  display: flex;
  justify-content: flex-end;
  gap: var(--s-4);
}
.acciones {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--s-4);
  padding-top: var(--s-6);
  border-top: var(--bw-hair) solid var(--border-hair);
}
.espacio {
  flex: 1;
}
@media (max-width: 900px) {
  .cuerpo {
    flex-direction: column;
    gap: var(--s-6);
  }
  .identidad {
    width: 100%;
  }
}
